import React, {useEffect, UseState} from "react";
import { FaFutbol, FaUser } from "react-icons/fa";
import HomeCard from "../../../components/HomeCard";
import MainView from "../../../components/MainView";

import './styles.css';


export default function AdminHome(props){
    return (
        <MainView
            adminMenu
            currentPage="home"
        >
        <div className='admin-home-page-message'>
            <h2>Bem vindo ao</h2>
            <h1>PORTAL <b>Boston</b>City</h1>
        </div>
        <hr />

        <div className="admin-home-page-cards">
            <HomeCard
                title="Academias"
                to="/admin/academias"
                //data="Listagem de Academias"
                icon={<FaFutbol/>}
            />

            <HomeCard
                title="Acessos"
                to="/admin/acessos"
                icon={<FaUser/>}
            />
        </div>


        </MainView>
    )
}